























import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocConvenzione } from "../../_models/docConvenzione";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ConvenzioneTirFormativoReview extends Vue {
  @Prop() docInfo!: DocConvenzione;
  private ruoloUtente: number[];
  private tipoAttivita: string;

  private elements: DocConvenzione;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.tipoAttivita = "";
    this.elements = {
      idConvenzione: this.docInfo.idConvenzione,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      indirizzoIstituto: this.docInfo.indirizzoIstituto,
      capIstituto: this.docInfo.capIstituto,
      comuneIstituto: this.docInfo.comuneIstituto,
      provinciaIstituto: this.docInfo.provinciaIstituto,
      telefonoIstituto: this.docInfo.telefonoIstituto,
      emailIstituto: this.docInfo.emailIstituto,
      codiceFiscaleIstituto: this.docInfo.codiceFiscaleIstituto,
      dirigenteIstituto: this.docInfo.dirigenteIstituto,
      luogoNascitaDirigenteIstituto: this.docInfo.luogoNascitaDirigenteIstituto,
      dataNascitaDirigenteIstituto: this.docInfo.dataNascitaDirigenteIstituto,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      capAzienda: this.docInfo.capAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      telefonoAzienda: this.docInfo.telefonoAzienda,
      emailAzienda: this.docInfo.emailAzienda,
      pecAzienda: this.docInfo.pecAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      luogoNascitaRappresentanteAzienda: this.docInfo
        .luogoNascitaRappresentanteAzienda,
      dataNascitaRappresentante: this.docInfo.dataNascitaRappresentante,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDoc: this.docInfo.idStatoDoc,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaIstituto: this.docInfo.firmaIstituto,
      tipoAttivita: this.docInfo.tipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate,
      codAteco: this.docInfo.codAteco,
      codIstat: this.docInfo.codIstat,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      tutorAziendale: this.docInfo.tutorAziendale,
      tutorFormativo: this.docInfo.tutorFormativo
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }

    var dd = {
      /**--------------------------------------------------------
         * Le immagini di header e footer sono convertite in Base64
         * ed importate dal file Header_Footer.js
         ----------------------------------------------------------*/
      pageSize: "A4",
      // ****** FOOTER *********//
      footer: function(/*currentPage, pageCount*/) {
        return [
          {
            image: images.authFooter,
            width: "560",
            height: "80",
            margin: [20, 0]
          }
        ];
      },
      // ******** HEADER ******** //
      header: function(/*currentPage, pageCount, pageSize*/) {
        // you can apply any logic and return any valid pdfmake element

        return [
          {
            // image: images.authHeader,
            image: images.authHeader,
            width: "525",
            height: "90",
            margin: [35, 0]
          }
        ];
      },

      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        {
          text:
            "Convenzione stipulata in data " +
            this.elements.dataDocumento +
            " con protocolo n. " +
            this.elements.numeroProtocollo,
          style: "bodyText",
          margin: [0, 70, 0, 20]
        },
        {
          text: "CONVENZIONE DI TIROCINIO",
          alignment: "center",
          bold: true,
          fontSize: 16,
          margin: [0, 0, 0, 0]
        },
        {
          text: "FORMATIVO E DI ORIENTAMENTO",
          alignment: "center",
          bold: true,
          fontSize: 16
        },
        {
          text: "TRA",
          alignment: "center",
          bold: true,
          fontSize: 16
        },
        {
          text: "Soggetto Promotore",
          bold: true,
          style: "bodyText",
          margin: [0, 5, 0, 10]
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Denominazione Istituto", style: "tableTitle" },
                {
                  text: this.elements.denominazioneIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Indirizzo", style: "tableTitle" },
                { text: this.elements.indirizzoIstituto, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.capIstituto +
                    " " +
                    this.elements.comuneIstituto +
                    " " +
                    this.elements.provinciaIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoIstituto, style: "tableText" }
              ],
              [
                { text: "Indirizzo e-mail", style: "tableTitle" },
                { text: "didattica@vallauri.edu", style: "tableText" }
              ],
              [
                { text: "PEC", style: "tableTitle" },
                { text: "CNISO1700C@PEC.ISTRUZIONE.IT", style: "tableText" }
              ],
              [
                { text: "Codice Fiscale / Partita IVA", style: "tableTitle" },
                {
                  text: this.elements.codiceFiscaleIstituto,
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Dirigente Scolastico/Legale Rappresentante",
                  style: "tableTitle"
                },
                { text: this.elements.dirigenteIstituto, style: "tableText" }
              ],
              [
                { text: "Nato a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaDirigenteIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaDirigenteIstituto,
                  style: "tableText"
                }
              ]
            ]
          }
        },
        {
          text: "E",
          alignment: "center",
          bold: true,
          fontSize: 16,
          margin: [0, 5, 0, 0]
        },
        {
          text: "Soggetto Ospitante",
          bold: true,
          style: "bodyText",
          margin: [0, 5, 0, 10]
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Denominazione Azienda", style: "tableTitle" },
                { text: this.elements.denominazioneAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo sede legale", style: "tableTitle" },
                { text: this.elements.indirizzoAzienda, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.capAzienda +
                    " " +
                    this.elements.comuneAzienda +
                    " " +
                    this.elements.provinciaAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo e-mail", style: "tableTitle" },
                { text: this.elements.emailAzienda, style: "tableText" }
              ],
              [
                { text: "PEC", style: "tableTitle" },
                { text: this.elements.pecAzienda, style: "tableText" }
              ],
              [
                { text: "Codice fiscale / Partita IVA", style: "tableTitle" },
                { text: this.elements.pIvaAzienda, style: "tableText" }
              ],
              [
                {
                  text: "Titolare / Legale Rappresentante",
                  style: "tableTitle"
                },
                {
                  text: this.elements.rappresentanteAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaRappresentanteAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaRappresentante,
                  style: "tableText"
                }
              ]
            ]
          }
        },
        {
          text: "Premesso",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Il tirocinio è una misura formativa di politica attiva, finalizzata a creare un contatto diretto tra un soggetto ospitante e il tirocinante allo scopo di favorirne l’arricchimento del bagaglio di conoscenze, l’acquisizione di competenze professionali e l’inserimento o il reinserimento lavorativo. Il tirocinio consiste in un periodo di orientamento al lavoro e di formazione in situazione che non si configura come un rapporto di lavoro. I Tirocini formativi e di orientamento, sono finalizzati ad agevolare le scelte professionali e l’occupabilità dei giovani nel percorso di transizione tra scuola e lavoro mediante una formazione a diretto contatto con il mondo del lavoro.",
          style: "bodyText",
          pageBreak: "after"
        },
        {
          text: "Si conviene quanto segue:",
          bold: true,
          style: "bodyText",
          margin: [0, 70, 0, 10]
        },
        {
          text: "Art. 1. Soggetti della convenzione",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Ai sensi della DGR n. 74-5911 del 03/06/2013 il Soggetto Ospitante " +
            this.elements.denominazioneAzienda +
            " si impegna ad accogliere presso le sue strutture un soggetto in 'Tirocinio Formativo e di Orientamento' su proposta del Soggetto Promotore, l'I.I.S. “G. VALLAURI” di FOSSANO (CN).",
          style: "bodyText"
        },
        {
          text:
            "Art. 2. Natura e durata del tirocinio formativo e di orientamento",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Ai sensi della DGR n. 74-5911 del 3 giugno 2013 attuativa della LR 34/08 artt. 38 –41 il tirocinio formativo e di orientamento non costituisce rapporto di lavoro.",
          style: "bodyText"
        },
        {
          text:
            "I tirocini di orientamento e formazione non possono avere una durata superiore ai sei mesi, proroghe comprese, ad eccezione dei tirocini destinati a persone svantaggiate o a persone particolarmente svantaggiate, che non possono superare la durata di dodici mesi proroghe comprese e i tirocini rivolti alle persone disabili, la cui durata non può superare i ventiquattro mesi proroghe comprese.",
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text: "Art. 3. Indennità di partecipazione e rimborso spese",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Sulla base di quanto previsto all’articolo 1, commi 34 – 36, della legge n. 92 del 2012 e in ottemperanza a quanto disciplinato dalla DGR n. 74-5911 del 3 giugno 2013 è corrisposta al tirocinante un’indennità minima di partecipazione al tirocinio pari a € 300,00 lordi per un impegno settimanale massimo di 20 ore. Tale importo aumenta proporzionalmente in relazione all’impegno del tirocinante fino ad un massimo di 40 ore settimanali, in coerenza con gli obiettivi del progetto formativo, corrispondente a un’indennità di partecipazione minima mensile pari a € 600,00 lordi. L’erogazione dell’indennità, salvo diverso accordo, è corrisposta dal soggetto ospitante. E’ in ogni caso facoltà del soggetto ospitante concordare indennità di valore superiore ai riferimenti sopra riportati.",
          style: "bodyText"
        },
        {
          text:
            "Al tirocinante percettore di forme di sostegno al reddito, per il quale non è prevista la corresponsione dell’indennità di partecipazione di cui sopra, il soggetto ospitante è tenuto a riconoscere il rimborso delle spese sostenute per vitto (buoni pasto nella misura prevista dai contratti di riferimento, ovvero in assenza, nella misura minima esente da imposizione contributiva e fiscale) e trasporto su mezzo pubblico, a fronte della presentazione degli appositi giustificativi.",
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text: "Art. 4 Progetto formativo",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Per ciascun tirocinante inserito nell'azienda ospitante, in base alla presente Convenzione, viene predisposto un Progetto Formativo, contenente:",
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          ul: [
            {
              text:
                "anagrafica: dati identificativi del tirocinante, dell’azienda o amministrazione pubblica, del soggetto promotore, del tutor individuato dal soggetto ospitante e del tutor o referente nominato del soggetto promotore;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "elementi descrittivi del tirocinio: tipologia di tirocinio, settore di attività economica dell’azienda (codici di classificazione ATECO) o dell’amministrazione pubblica, area professionale di riferimento dell’attività del tirocinio (codici di classificazione CP ISTAT), sede prevalente di svolgimento, estremi identificativi delle assicurazioni, durata, periodo di svolgimento, impegno orario del tirocinio, entità dell’importo corrisposto quale indennità al tirocinante; ",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "specifiche del progetto formativo: a) indicazione della figura professionale di riferimento nel Repertorio nazionale di cui alla legge n. 92/2012, art. 4, comma 67, ed eventuale livello EQF. Nelle more della definizione del Repertorio nazionale si fa riferimento al repertorio regionale degli standard formativi (di cui alla D.G.R. 152 – 3672 del 2 agosto 2006 e s.m.i.); b) obiettivi del tirocinio; c) competenze da acquisire con riferimento alla figura/profilo formativo e professionale di riferimento; d) processi/attività in cui opera il tirocinante associati, ove possibile, alle competenze da acquisire; e) modalità di svolgimento e strumenti;",
              style: "bodyText",
              margin: [0, 0, 0, 5],
              pageBreak: "after"
            },
            {
              text:
                "diritti e doveri delle parti coinvolte nel progetto di tirocinio: tirocinante, tutor del soggetto ospitante e referente o tutor del soggetto promotore. ",
              style: "bodyText",
              margin: [0, 70, 0, 0]
            }
          ]
        },
        {
          text: "Art. 5. Obblighi del soggetto promotore",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "Nel presidiare la qualità dell’esperienza di tirocinio il soggetto promotore deve:",
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          ul: [
            {
              text:
                "favorire l’attivazione dell’esperienza di tirocinio supportando il soggetto ospitante e il tirocinante nella fase di avvio nella gestione delle procedure amministrative e nella predisposizione del progetto formativo secondo le disposizioni e i modelli regionali oggetto di apposito provvedimento;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "individuare un referente o tutor quale responsabile organizzativo del tirocinio;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "promuovere il buon andamento dell’esperienza di tirocinio attraverso un’azione di accompagnamento e monitoraggio in itinere;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "rilasciare, sulla base della valutazione del soggetto ospitante, l’attestazione dei risultati, specificando le competenze, abilità e conoscenze eventualmente acquisite operando in coerenza con il processo di individuazione e validazione delle competenze definito dalla Regione in ottemperanza a quanto previsto dall’art. 4 della Legge 92/2012 e dal successivo Dlgs 13/2013;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "contribuire al monitoraggio territoriale dell’andamento dei tirocini. A tal fine il soggetto promotore redige con cadenza annuale un rapporto sintetico di analisi dei tirocini realizzati, al fine di evidenziarne i risultati in termini di inserimento/reinserimento lavorativo. Il Rapporto è inviato alla Regione e reso disponibile attraverso la pubblicazione sul sito internet del soggetto promotore, nel rispetto delle disposizioni in materia di tutela dei dati personali.",
              style: "bodyText"
            }
          ]
        },
        {
          text:
            "Il Soggetto Promotore si fa inoltre garante che i propri tirocinanti siano stati formati e che abbiano conseguito l'Attestato del 'Corso di informazione e formazione sulla sicurezza e salute negli ambienti di lavoro', come previsto dal Decreto Legislativo n.81 del 09/04/2008, “Testo Unico in materia di tutela della salute e sicurezza sui luoghi di lavoro” e s.m.i., conformemente alle ore previste dal settore di interesse (Livello di rischio alto 16 ore per i settori Meccanico, Elettrotecnico – Livello di rischio basso 8 ore per il settore Informatico).",
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text: "Art. 6. Obblighi del soggetto ospitante",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text: "Il soggetto ospitante deve:",
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          ul: [
            {
              text:
                "stipulare la convenzione con il soggetto promotore e definire il progetto formativo, in collaborazione con il soggetto promotore;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "designare un tutor aziendale con funzioni di affiancamento al tirocinante sul luogo di lavoro, individuato tra i propri lavoratori in possesso di competenze professionali adeguate e coerenti con il progetto formativo individuale. Nel caso di imprese con meno di 15 dipendenti e di imprese artigiane, il tutor può essere il titolare o un amministratore dell’impresa, un socio o un famigliare coadiuvante inserito nell’attività dell’impresa; ",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "assicurare la realizzazione del percorso di tirocinio secondo quanto previsto dal progetto formativo;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "valutare l’esperienza svolta dal tirocinante ai fini del rilascio, da parte del soggetto promotore, dell’attestazione dell’attività svolta e delle competenze eventualmente acquisite;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "affidare ai tirocinanti esclusivamente attività coerenti con gli obiettivi formativi del tirocinio stesso e il loro impegno presso l’impresa non dovrà superare l’orario previsto dal contratto collettivo nazionale di lavoro di riferimento;",
              style: "bodyText",
              margin: [0, 0, 0, 5],
              pageBreak: "after"
            },
            {
              text:
                "far svolgere l’attività presso strutture aziendali (stabilimenti, sedi, reparti, uffici, ecc.) che rispettino le vigenti disposizioni normative in tema di prevenzione incendi, igiene e sicurezza del lavoro garantendo il rispetto di quanto previsto in materia di sorveglianza sanitaria ai sensi del D. Lgs n. 81/2008, “Testo Unico in materia di tutela della salute e sicurezza sui luoghi di lavoro” e s.m.i. ed a fornire, ai sensi dell’art. 37, all’avvio del tirocinio, sufficiente e adeguata formazione specifica in materia e, ove necessario, gli eventuali dispositivi di protezione individuale (DPI) e, ove necessario, farsi carico della visita medica;",
              style: "bodyText",
              margin: [0, 70, 0, 5]
            },
            {
              text:
                "segnalare al Soggetto Promotore e agli istituti assicurativi ogni eventuale incidente occorso svolgimento del tirocinio, entro i tempi previsti dalla normativa vigente;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "effettuare la comunicazione di avvio del tirocinio (mod. UniLav), nei termini e nei modi previsti dal DGR 74-5911.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "conservare la copia originale della convenzione e del progetto formativo ed eventualmente esibirli su richiesta agli enti istituzionali presenti sul territorio.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "sospendere e/o interrompere l'attività di tirocinio, informando tempestivamente il Soggetto Promotore, nei casi in cui:",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              ul: [
                {
                  text:
                    "la formazione alla sicurezza posseduta dagli studenti, in relazione al D. Lgs. 81/2008, non sia idonea allo svolgimento di una o più attività previste dal Progetto formativo;",
                  style: "bodyText",
                  margin: [50, 0, 0, 5]
                },
                {
                  text:
                    "dovessero difettare o venir meno le condizioni di incolumità degli studenti in tirocinio in riferimento allo svolgimento di una o di tutte le attività previste dal Progetto Formativo;",
                  style: "bodyText",
                  margin: [50, 0, 0, 5]
                }
              ]
            },
            {
              text:
                "garantire agli studenti beneficiari del percorso, attraverso il Tutor esterno/aziendale, l’assistenza e la formazione necessarie al buon esito dell’attività prevista, nonché la dichiarazione delle competenze acquisite nel contesto di lavoro;",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text: "consentire al Tutor scolastico di:",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              ul: [
                {
                  text:
                    "monitorare l'attività mediante contatti telefonici e/o e-mail indirizzate al Tutor esterno;",
                  style: "bodyText",
                  margin: [50, 0, 0, 5]
                },
                {
                  text:
                    "raggiungere e visitare gli studenti in tirocinio sul luogo effettivo di svolgimento dell'attività sede aziendale, cantiere mobile o reparto normalmente chiuso al pubblico.",
                  style: "bodyText",
                  margin: [50, 0, 0, 5]
                }
              ]
            },
            {
              text:
                "garantire un’organizzazione degli spazi tale da ridurre al massimo il rischio di prossimità e di aggregazione, e che vengano adottate misure organizzative di prevenzione e di protezione, contestualizzate al settore produttivo di riferimento, con riguardo alle specifiche esigenze delle persone con disabilità, di cui al “Documento tecnico sulle possibile rimodulazione delle misure di contenimento del contagio da SARS – CoV- 2 nei luoghi di lavoro e strategie di prevenzione pubblicato dall’INAIL e di cui alla normativa sanitaria nazionale”",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "Il soggetto ospitante è obbligato a stipulare l’assicurazione del tirocinante contro gli infortuni sul lavoro e per la responsabilità civile verso terzi. Le coperture assicurative devono riguardare anche le attività eventualmente svolte dal tirocinante al di fuori dell’azienda.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        // {
        //   ul: [
        //     {
        //       text:
        //         "garantire un’organizzazione degli spazi tale da ridurre al massimo il rischio di prossimità e di aggregazione, e che vengano adottate misure organizzative di prevenzione e di protezione, contestualizzate al settore produttivo di riferimento, con riguardo alle specifiche esigenze delle persone con disabilità, di cui al “Documento tecnico sulle possibile rimodulazione delle misure di contenimento del contagio da SARS – CoV- 2 nei luoghi di lavoro e strategie di prevenzione pubblicato dall’INAIL e di cui alla normativa sanitaria nazionale”",
        //       style: "bodyText",
        //       margin: [50, 0, 0, 5]
        //     }
        //   ]
        // },
        {
          text:
            "Il Soggetto Ospitante non può realizzare più di un tirocinio con il medesimo tirocinante, fatta salva la possibilità di proroga circoscritta al limite massimo di durata indicato per ogni tipologia di tirocinio.",
          style: "bodyText"
        },
        {
          text:
            "Il Soggetto Ospitante si impegna, ove esiste, a permettere ai tirocinanti l’accesso al servizio di mensa aziendale o al buono pasto sostitutivo.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text:
            "Il Soggetto Ospitante si impegna a trasmettere al Soggetto Promotore, al termine del tirocinio, il registro delle presenze giornaliere e a collaborare con il Soggetto Promotore per la valutazione finale dell'attività con riferimento al raggiungimento degli obiettivi.",
          style: "bodyText"
        },
        {
          text: "Art. 7. Sospensione e recesso anticipato del tirocinio",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          ul: [
            {
              text:
                "Il tirocinio si considera sospeso in caso di maternità, infortunio, chiusura collettiva o malattia lunga, intendendosi per tale quella che si protrae per una durata pari o superiore ad un terzo del tirocinio. Il periodo di sospensione non concorre al computo della durata complessiva del tirocinio secondo i limiti massimi precedentemente indicati.",
              style: "bodyText",
              margin: [0, 0, 0, 5],
              pageBreak: "after"
            },
            {
              text:
                "Il tirocinio formativo e di orientamento può essere interrotto e/o modificato dal tirocinante, previo avviso al Soggetto Ospitante ed al Soggetto Promotore, di almeno cinque giorni lavorativi, in caso di iscrizione ad un corso di studi universitario, di iscrizione ad un corso di Istruzione Tecnica Superiore o di assunzione stabile presso altra azienda.",
              style: "bodyText",
              margin: [0, 70, 0, 5]
            },
            {
              text:
                "Il soggetto ospitante può interrompere il tirocinio nel caso in cui il tirocinante non rispetti le regole sottoscritte nel progetto formativo o risulti impraticabile l’aggiornamento del progetto formativo stesso.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text: "Art. 8. Ulteriori consegne",
          bold: true,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "L’orario di permanenza in azienda è concordato tra il Soggetto Ospitante, il Tirocinante e il Soggetto Promotore, in funzione degli obiettivi formativi del tirocinio e valutando eventuali esigenze di studio del Tirocinante stesso",
          style: "bodyText"
        },
        {
          text:
            "L'impegno orario settimanale non potrà eccedere il normale orario previsto per il personale interno, di norma, salvo diversa organizzazione aziendale, 8 ore giornaliere per 5 giorni settimanali.",
          style: "bodyText"
        },
        {
          text:
            "Le parti sono tenute a consegnare al tirocinante copia del progetto formativo e gli estremi della convenzione. Per tutto quanto non previsto dalla presente Convenzione le parti fanno riferimento alla legislazione vigente.",
          style: "bodyText"
        },
        {
          text:
            "La presente convenzione ha una durata di un anno dalla data di sottoscrizione.",
          style: "bodyText",
          margin: [0, 5, 0, 0]
        },
        {
          text:
            "Il soggetto ospitante con la sottoscrizione accetta le modifiche introdotte nella presente convenzione, a riguardo delle coperture assicurative (vedi art. 6).",
          style: "bodyText",
          margin: [0, 5, 0, 0]
        },
        {
          text: "Fossano, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text: "Firma SOGGETTO PROMOTORE",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: "Il Dirigente Scolastico",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: this.elements.dirigenteIstituto,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: images.firmaVallauri,
          width: 200,
          alignment: "right"
        },
        {
          text: "Firma SOGGETTO OSPITANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 70, 0, 0]
        },
        {
          text: "Legale Rappresentante",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: this.elements.rappresentanteAzienda,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: this.elements.firmaAzienda,
          width: 200,
          alignment: "right"
        }
      ],
      styles: {
        bodyText: {
          fontSize: 10,
          justified: true
        },
        tableTitle: {
          fontSize: 10,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        },
        tableTextHigh: {
          fontSize: 8,
          background: "yellow"
        }
      }
    };
    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);

    const pdfDocGenerator = pdfMake.createPdf(json);
    // const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoIstituto_%%/g,
      this.elements.indirizzoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_capIstituto_%%/g,
      this.elements.capIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_comuneIstituto_%%/g,
      this.elements.comuneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaIstituto_%%/g,
      this.elements.provinciaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoIstituto_%%/g,
      this.elements.telefonoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_emailIstituto_%%/g,
      this.elements.emailIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleIstituto_%%/g,
      this.elements.codiceFiscaleIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dirigenteIstituto_%%/g,
      this.elements.dirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaDirigenteIstituto_%%/g,
      this.elements.luogoNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaDirigenteIstituto_%%/g,
      this.elements.dataNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_capAzienda_%%/g,
      this.elements.capAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAzienda_%%/g,
      this.elements.telefonoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_emailAzienda_%%/g,
      this.elements.emailAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pecAzienda_%%/g,
      this.elements.pecAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaRappresentanteAzienda_%%/g,
      this.elements.luogoNascitaRappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaRappresentante_%%/g,
      this.elements.dataNascitaRappresentante
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_tipoAttivita_%%/g,
      this.elements.tipoAttivita
    );
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );

    return completeDoc;
  }

  confirm() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchConfirmConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione accettata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idConvenzione: this.elements.idConvenzione
    };
    if (this.elements.firmaAzienda !== null) {
      user
        .dispatchRefuseConvenzione(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Convenzione rifiutata con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();

    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        if (this.docInfo.tipoAttivita === "tirocinioReIns") {
          this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
          this.tipoAttivita = "tirocinio formativo e di orientamento";
        }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }
}
